
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

const state = {
    TaskNoteList: [],
    TaskNoteTypeList: [],
    TaskNoteNoMoreData: false,
    Loading: false,
    UpdateTaskNoteList: true,
};


const getters = {
    GetTaskNoteList(state: any) {
        return state.TaskNoteList;
    },
    GetTaskNoteNoMoreData(state: any) {
        return state.TaskNoteNoMoreData;
    },
    GetUpdateTaskNoteList(state: any) {
        return state.UpdateTaskNoteList;
    },
    GetTaskNoteTypeList(state: any) {
        return state.TaskNoteTypeList;
    },

};

const mutations = {

    SetTaskNoteList(state: any, list: any) {
        state.TaskNoteList = list;
    },
    AddTaskNoteList(state: any, list: any) {
        state.TaskNoteList = state.TaskNoteList.concat(list);
    },
    SetTaskNoteNoMoreData(state: any, val: any) {
        state.TaskNoteNoMoreData = val;
    },
    SetUpdateTaskNoteList(state: any, val: any) {
        state.UpdateTaskNoteList = val;
    },
    SetUpdateTaskNoteTypeList(state: any, val: any) {
        state.TaskNoteTypeList = val;
    }
};

const actions = {
    GetTaskNoteTypeListFromServer(context) {
        context.commit("SetLoading", true);
        axios.get("TaskNote/GetTaskNoteTypeList")
            .then(data => {
                context.commit("SetLoading", false);
                context.commit("SetUpdateTaskNoteTypeList", data.data);
            });
    },
    GetTaskNoteListFromServer(context: any, Filter: any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("TaskNote/GetTaskNoteList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey: Filter.searchKey
            }
        })
            .then(data => {
                context.commit("SetLoading", false);
                context.commit('SetUpdateTaskNoteList', false);

                if (data.data.length < 1) {
                    context.commit("SetTaskNoteNoMoreData", true);
                    if (Filter.pageId == 1) {
                        context.commit("SetTaskNoteList", data.data);
                    }
                    return;
                }
                if (Filter.pageId == 1) {
                    context.commit("SetTaskNoteNoMoreData", false);
                    context.commit("SetTaskNoteList", data.data);
                }
                else {
                    context.commit("SetTaskNoteNoMoreData", false);
                    context.commit("AddTaskNoteList", data.data);
                }
            });
    },


    ClearTaskNoteList(context: any) {
        context.commit("SetTaskNoteList", []);
    },

    CreateTaskNote(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('TaskNote/TaskNoteCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                context.commit('SetUpdateTaskNoteList', true);
                setTimeout(function () { router.push('/TaskNoteList'); }, 1500);
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditTaskNote(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('TaskNote/TaskNoteCreate', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: any) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                context.commit('SetUpdateTaskNoteList', true);
                setTimeout(function () { router.push('/TaskNoteList'); }, 1500);
            }
            context.commit("SetLoading", false);
        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
